import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "row", "group", "empty"]

  connect() {
    this.activeFilter = "all"
    this.observer = new MutationObserver(() => this._apply())
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  show(event) {
    this.activeFilter = event.currentTarget.dataset.filter

    this.buttonTargets.forEach((button) => {
      const active = button === event.currentTarget
      button.classList.toggle("active", active)
      button.setAttribute("aria-pressed", active.toString())
    })

    this._apply()
  }

  _apply() {
    this.rowTargets.forEach((row) => {
      row.hidden = this.activeFilter === "unread" && row.dataset.unread !== "true"
    })

    this.groupTargets.forEach((group) => {
      group.hidden = !group.querySelector('[data-notification-filter-target="row"]:not([hidden])')
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.hidden = this.activeFilter !== "unread" || this.rowTargets.some((row) => !row.hidden)
    }
  }
}
